import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
import { AuthService } from './auth.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  localInfo :any;
  constructor(private authService: AuthService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    // const currentUser = this.authService.currentUserValue;
  

    this.localInfo = JSON.parse(localStorage.getItem('access') || '{}');
    // console.log("this.localInfo =======> ",this.localInfo)
    if(this.localInfo && this.localInfo.id){
      return true;
    }else{
      this.authService.logout();
      return false;
      // return true;
    }

    // debugger
    // if (currentUser) {
    //   // logged in so return true
      // return true;
    // }

    // not logged in so redirect to login page with the return url
    // this.authService.logout();
    // return false;
  }
}
